module.exports = __webpack_public_path__ + "media/images/payments/verisign-dark-2bf489b8013447621771d80d9abf8b01.svg";